// Module
var code = " <p translate=\"PURCHASE_ITEM_UNITS_REMAINING_LABEL\" class=\"item-amount-label\"></p> ";
// Exports
export default code;